'use es6';

import styled from 'styled-components';
import ErrorState from '../../components/ErrorState';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadHistoryErrorWrapper = styled.div.withConfig({
  displayName: "ThreadHistoryError__ThreadHistoryErrorWrapper",
  componentId: "eons6g-0"
})(["text-align:center;flex-grow:1;"]);
const ThreadHistoryError = () => {
  return /*#__PURE__*/_jsx(ThreadHistoryErrorWrapper, {
    children: /*#__PURE__*/_jsx(ErrorState, {})
  });
};
ThreadHistoryError.displayName = 'ThreadHistoryError';
export default ThreadHistoryError;